let navUtils = {
    defaultScrollDelay: 1000,
    // scroll smoothly to element with target ID allowing for fixed header
    scrollTo: function(target) {
        let targetId = this.getIdFromTarget(target);
        const targetEl = document.getElementById(targetId);
        if (targetEl) {
            const topMargin = this.getTopMargin(targetEl);
            const headerHeight = this.getHeaderHeight();
            targetEl.style.scrollMarginTop = `${headerHeight + topMargin}px`;
            targetEl.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    },
    scrollAfterTimeout(target) {
        setTimeout(() => {
            navUtils.scrollTo(target);
          }, (typeof scrollDelay !== 'undefined') ? scrollDelay : navUtils.defaultScrollDelay );
    },
    scrollToWithCorrection(target, trigger) {
        this.scrollTo(target);
        if (!trigger.classList.contains('js-init')) {
            this.scrollAfterTimeout(target);
            trigger.classList.add('js-init');
        }
    },
    // scroll smoothly to top of page
    scrollToTop: function() {
        document.body.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    },
    // get ID from the target if it includes hash
    getIdFromTarget: function(target) {
        if (target.charAt(0) === '#') {
            target = target.substring(1);
        }
        return target;
    },
    // calculate the fixed header height
    getHeaderHeight: function() {

        // assume we always have a header component
        const mainHeaderHeight = document.querySelector('.header-component').offsetHeight;

        // check for submenu component
        const submenuComponent = document.querySelector('.submenu-component');
        let submenuHeight = 0;
        if (submenuComponent) {
            submenuHeight = submenuComponent.offsetHeight;
        }

        // check for submenu component submenu
        const submenuComponentSubmenu = document.getElementById('submenuNav');
        let submenuSubmenuHeight = 0;
        if (submenuComponentSubmenu) {
            // calculate height, the submenu has negative top margin we need to account for
            let submenuComputedStyle = window.getComputedStyle(submenuComponentSubmenu);
            let marginTop = parseInt(submenuComputedStyle.marginTop) || 0;
            submenuSubmenuHeight = submenuComponentSubmenu.offsetHeight + marginTop;
        }
        return Math.ceil(mainHeaderHeight + submenuHeight + submenuSubmenuHeight);
    },
    getTopMargin: function(target) {
        // Top margins on containers vary, so use a fixed margin of 16px for consistency
        let marginTop = 16;
        // reduce to 8px for Tablet and Mobile
        if (this.isTabletOrMobile() ) {
            marginTop = 8;
        }
        return marginTop;
    },
    isTabletOrMobile: function() {
        return window.matchMedia('(max-width: 1023px)').matches;
    }
};